import { formatCurrencyBRL } from '../commercialFormatters';

const numberFormat = new Intl.NumberFormat('pt-BR', {
  maximumFractionDigits: 2,
});
const percentFormat = new Intl.NumberFormat('pt-BR', {
  maximumFractionDigits: 1,
});

export const formatPercent = value => `${percentFormat.format(value)}%`;

// Valor de um widget conforme o `format` devolvido pelo backend.
export const formatWidgetValue = (value, format) => {
  if (value === null || value === undefined) return '—';
  if (format === 'currency') return formatCurrencyBRL(value);
  if (format === 'percent') return formatPercent(value);
  return numberFormat.format(value);
};
